import { FC, FormEventHandler, PropsWithChildren, ReactNode } from "react";

import { Box, Text, Title, createStyles, BackgroundImage } from "@mantine/core";

import { Logo } from "@components/Logo/Logo";
import { LanguageSelector } from "@components/LanguageSelector/LanguageSelector";

const useStyles = createStyles((t) => ({
  wrapper: {
    flex: 1,
    display: "grid",
    justifyItems: "center",
    gridTemplateColumns: "repeat(2, 1fr)",
    [`@media (max-width: ${t.breakpoints.md}px)`]: {
      gridTemplateColumns: "1fr !important",
    },
  },
  image: {
    [`@media (max-width: ${t.breakpoints.md}px)`]: {
      display: "none",
    },
  },
  formWrapper: {
    gap: 20,
    width: "100%",
    maxWidth: 500,
    display: "flex",
    paddingBlock: 82,
    flexDirection: "column",
    paddingInline: t.spacing.lg,
    justifyContent: "space-between",
  },
  form: {
    display: "flex",
    gap: t.spacing.lg,
    flexDirection: "column",
  },
  formTitle: {
    display: "flex",
    gap: t.spacing.md,
    flexDirection: "column",
  },
  fieldsWrapper: {
    display: "flex",
    gap: t.spacing.md,
    flexDirection: "column",
  },
  logo: {
    alignSelf: "center",
  },
  languageSelector: {
    right: 20,
    bottom: 20,
    position: "fixed",
  },
}));

export const FormWithImage: FC<
  PropsWithChildren & {
    title: string;
    description: ReactNode;
    imageUrl?: string;
    onSubmit?: FormEventHandler<HTMLFormElement>;
  }
> = ({
  title,
  children,
  description,
  onSubmit,
  imageUrl = "https://images.pexels.com/photos/2526419/pexels-photo-2526419.jpeg?auto=compress&cs=tinysrgb&w=1600",
}) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.wrapper}>
      <BackgroundImage src={imageUrl} className={classes.image} />
      <Box className={classes.formWrapper}>
        <Logo className={classes.logo} />
        <Box className={classes.form}>
          <Box className={classes.formTitle}>
            <Title>{title}</Title>
            <Text color="dimmed">{description}</Text>
          </Box>
          <form className={classes.fieldsWrapper} onSubmit={onSubmit}>
            {children}
          </form>
        </Box>
        <Box />
        <LanguageSelector className={classes.languageSelector} />
      </Box>
    </Box>
  );
};
